import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';
import Link from 'next/link';

const dailyVerses = [
{
  id: 1,
  verse: "She is clothed with strength and dignity; she can laugh at the days to come.",
  reference: "Proverbs 31:25",
  image: "https://images.unsplash.com/photo-1651370380274-8873da6ee568",
  alt: "Confident woman in flowing white dress standing on mountain peak at sunrise with arms outstretched"
},
{
  id: 2,
  verse: "For I know the plans I have for you, declares the Lord, plans to prosper you and not to harm you.",
  reference: "Jeremiah 29:11",
  image: "https://images.unsplash.com/photo-1666910800969-9b68cd1ac34e",
  alt: "Peaceful woman with closed eyes in prayer surrounded by golden sunlight in nature"
},
{
  id: 3,
  verse: "The Spirit of the Lord is on me, because he has anointed me to proclaim good news.",
  reference: "Luke 4:18",
  image: "https://images.unsplash.com/photo-1696818511386-158129e6ad24",
  alt: "Diverse group of women holding hands in circle during outdoor prayer gathering"
}];


export default function HeroSection() {
  const currentVerse = dailyVerses?.[0];

  return (
    <section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden bg-gradient-to-br from-primary/10 via-background to-accent/10">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <AppImage
          src={currentVerse?.image}
          alt={currentVerse?.alt}
          className="w-full h-full object-cover opacity-20" />

        <div className="absolute inset-0 bg-gradient-to-r from-background/90 via-background/70 to-background/90"></div>
      </div>
      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 text-center">
        <div className="mb-8">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-primary/10 text-primary text-sm font-inter font-medium mb-6">
            <Icon name="SparklesIcon" size={16} className="mr-2" />
            Daily Inspiration • November 12, 2024
          </div>
          
          <h1 className="text-4xl md:text-6xl font-crimson font-semibold text-foreground mb-6 leading-tight">
            Where Ancient Truth
            <span className="block text-primary">Meets Modern Life</span>
          </h1>
          
          <p className="text-lg md:text-xl text-muted-foreground font-source-serif max-w-2xl mx-auto mb-8">
            Discover divine wisdom through multiple formats—read, listen, and connect with scripture 
            in ways that speak to your soul and honor your spiritual journey.
          </p>
        </div>

        {/* Daily Verse Card */}
        <Link
          href="/bible-reader"
          className="inline-block bg-card/95 backdrop-blur-sm rounded-2xl p-8 mb-8 shadow-lg border border-border max-w-2xl mx-auto hover-lift contemplative-transition cursor-pointer">

          <div className="flex items-center justify-center mb-4">
            <Icon name="BookOpenIcon" size={24} className="text-primary mr-2" />
            <span className="text-sm font-inter font-medium text-primary">Today's Verse</span>
          </div>
          
          <blockquote className="text-xl md:text-2xl font-crimson text-foreground mb-4 leading-relaxed">
            "{currentVerse?.verse}"
          </blockquote>
          
          <cite className="text-primary font-inter font-medium">
            — {currentVerse?.reference}
          </cite>
        </Link>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link
            href="/personal-dashboard"
            className="bg-primary text-primary-foreground px-8 py-4 rounded-xl font-inter font-semibold text-lg hover-lift contemplative-transition flex items-center">

            <Icon name="UserPlusIcon" size={20} className="mr-2" />
            Start Your Journey
          </Link>
          
          <Link
            href="/digital-books-library"
            className="bg-surface text-foreground px-8 py-4 rounded-xl font-inter font-semibold text-lg hover-lift contemplative-transition border border-border flex items-center">

            <Icon name="PlayIcon" size={20} className="mr-2" />
            Explore Content
          </Link>
        </div>

        {/* Quick Stats */}
        <div className="flex flex-wrap justify-center gap-8 mt-12 text-center">
          <Link href="/community-hub" className="flex flex-col hover-lift contemplative-transition">
            <span className="text-2xl font-crimson font-semibold text-primary">50K+</span>
            <span className="text-sm text-muted-foreground font-inter">Active Readers</span>
          </Link>
          <Link href="/audio-book-library" className="flex flex-col hover-lift contemplative-transition">
            <span className="text-2xl font-crimson font-semibold text-primary">1,200+</span>
            <span className="text-sm text-muted-foreground font-inter">Audio Hours</span>
          </Link>
          <Link href="/live-streams-hub" className="flex flex-col hover-lift contemplative-transition">
            <span className="text-2xl font-crimson font-semibold text-primary">24/7</span>
            <span className="text-sm text-muted-foreground font-inter">Live Streams</span>
          </Link>
        </div>
      </div>
    </section>);

}